import { render, staticRenderFns } from "./UserCoachAppEvents.vue?vue&type=template&id=6a940b0f"
import script from "./UserCoachAppEvents.vue?vue&type=script&lang=js"
export * from "./UserCoachAppEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports